import React from 'react';
import PropTypes from 'prop-types';
import ImageSvg from '../image/ImageSvg';

const VerificationImages = (props) => {
  const { example, image, error } = props;

  return (
    <div className="verification-img-container pts">
      <div
        className="verification-img dib mrxs"
        style={{ backgroundImage: `url(${example})` }}
      >
        <ImageSvg
          svg="icon-check-2"
          iconClass="icon--blue icon--verification-large poa absr absb mbs mrs"
        />
      </div>
      {image && (
        <div
          className="verification-img dib"
          style={{ backgroundImage: `url(${image})` }}
        >
          {error && (
            <ImageSvg
              svg="icon-warning"
              iconClass="icon--red icon--verification-large poa absr absb mbs mrs"
            />
          )}
        </div>
      )}
    </div>
  );
};

VerificationImages.propTypes = {
  example: PropTypes.string,
  image: PropTypes.string,
  error: PropTypes.bool,
};

VerificationImages.defaultProps = {
  example: '',
  image: '',
  error: false,
};

export default VerificationImages;
